import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqData = [
  {
    id: null,
    question: 'Is there any commitment?',
    answer: 'No. Monthly subscription, no commitment. You can cancel at any time. Unused credits are non-refundable but stay valid for 6 months, so you have full flexibility to use them at your own pace.',
  },
  {
    id: null,
    question: 'How does the subscription work?',
    answer: 'Each plan includes a set number of properties per month. One property = one credit, whether you choose the standard option (Matterport only) or the option with drone clips (Matterport + drone).',
  },
  {
    id: null,
    question: 'What do I need to send?',
    answer: 'Just the link to your Matterport tour. If you choose the plan with drone, also share your clips via Google Drive, Dropbox, or WeTransfer. That’s it.',
  },
  {
    id: null,
    question: 'What do I get per property?',
    answer: 'Standard option: 1 professional walkthrough video in Full HD, delivered in 24h, ready to post on your listings, portals, and socials. With drone: 1 full edited video combining your Matterport tour and your drone clips, delivered in 24h. Unbranded version included (MLS-ready). In both cases you get a turnkey professional video file.',
  },
  {
    id: 'faq-turnaround',
    question: 'Delivery time?',
    answer: '24 hours. Orders placed Monday through Thursday are delivered the next day. Friday = delivery on Monday.',
  },
  {
    id: null,
    question: 'Can I buy extra credits?',
    answer: 'Yes. Extra credits are $95 per property (Matterport only) or $135 (with drone). No limit.',
  },
  {
    id: null,
    question: 'Unused credits?',
    answer: 'Unused credits are non-refundable but stay valid for 6 months. Use them when you need them—no pressure.',
  },
];

const FAQ: React.FC = () => {
  const [openItems, setOpenItems] = useState<number[]>([]);

  const toggleItem = (index: number) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
  };

  return (
    <section id="faq" className="py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-manrope text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 animate-fade-in-up">
            Frequently asked questions
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Answers to the most common questions about our service
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <div
                key={index}
                id={faq.id || undefined}
                className="card-hover bg-white rounded-3xl border border-[#E2E8F0] overflow-hidden"
              >
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                >
                  <span className="font-manrope font-semibold text-gray-900 pr-4">Q: {faq.question}</span>
                  {openItems.includes(index) ? (
                    <ChevronUp className="w-5 h-5 text-[#3C59B2] flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  )}
                </button>
                <div
                  className="grid transition-[grid-template-rows] duration-300 ease-out"
                  style={{ gridTemplateRows: openItems.includes(index) ? '1fr' : '0fr' }}
                >
                  <div className="min-h-0 overflow-hidden">
                    <div className="px-6 pb-4">
                      <div className="pt-2 border-t border-gray-100">
                        <p className="text-gray-700 leading-relaxed">
                          <span className="font-semibold text-[#3C59B2]">A: </span> {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
